import {Injectable} from '@angular/core';
import {CurrencyType} from '../components/table-view/table-view.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  defaultCurrencyType = CurrencyType.EUR;
  selectedCurrency: CurrencyType = this.defaultCurrencyType;

  sourceData: any = [];
  calculatedRatio: Array<any> = [];

  mergedData = [];

  constructor() {
  }

  applyCurrency(sourceData: any) {
    this.sourceData = sourceData;

    return this.calculateCurrency(this.sourceData, this.calculatedRatio, this.selectedCurrency);
  }

  calculateCurrency(sourceData: any, calculatedRatio: Array<any>, currency: CurrencyType) {

    this.sourceData = sourceData;
    this.calculatedRatio = calculatedRatio;
    this.selectedCurrency = currency;

    const data = JSON.parse(JSON.stringify(sourceData));

    if (currency !== CurrencyType.NONE && calculatedRatio) {
      data.forEach(row => {
        const locCurrency = row['Loc_Currency'];
        const ratio = calculatedRatio.find(r => r['Currency_code'] === locCurrency);

        if (ratio) {
          PRICE_COLUMNS.forEach(key => {
            if (row.hasOwnProperty(key)) {
              row[key] = row[key] * ratio['ratio'];
            }
          });
          row['Loc_Currency'] = this.getCurrencyId(currency);
        }
      });
    } else if (currency === CurrencyType.NONE) {
      this.selectedCurrency = this.defaultCurrencyType;
    }

    return data;
  }

  private getCurrencyId(currency: CurrencyType) {
    switch (currency) {
      case CurrencyType.CHF:
        return 'CHF';
      case CurrencyType.EUR:
        return 'EUR';
      case CurrencyType.GBP:
        return 'GBP';
      case CurrencyType.USD:
        return 'USD';
    }
  }
}

export const PRICE_COLUMNS = [
  'ExF_excl_VAT',
  'ExF_excl_VAT_from',
  'ExF_excl_VAT_to',
  'ExF_excl_VAT_unit',
  'WHS_excl_VAT',
  'WHS_excl_VAT_from',
  'WHS_excl_VAT_to',
  'WHS_excl_VAT_unit',
  'Ret_incl_VAT',
  'Ret_incl_VAT_from',
  'Ret_incl_VAT_to',
  'Ret_incl_VAT_unit',
  'Ret_excl_VAT',
  'Ret_excl_VAT_from',
  'Ret_excl_VAT_to',
  'Ret_excl_VAT_unit',
  'ExF_net_price',
  'Net_ExFactory_price',
  'Hospital_price',
  'Tender_ExFactory_price'
];
